import '@eg-maps/commons';
import { createContext } from 'react';

var UitkEGMapsType;
(function (UitkEGMapsType) {
    UitkEGMapsType["MAPBOX"] = "mapbox";
    UitkEGMapsType["GOOGLE"] = "google";
})(UitkEGMapsType || (UitkEGMapsType = {}));
var UitkEGMapsContext = createContext(null);

export { UitkEGMapsContext, UitkEGMapsType };
